import React from "react";
import {connect} from "react-redux";
import {FilterModes, setFilterMode, selectFilter, innerResetAll, updateResults} from "../../store/actions";

const CountMatches = (props) => {
  return props.render && (
    <>
      {props?.count > 0 &&
        <div ref={ProductFinder.countRef} className="count-matches">
          {props.strings['STRING:MATCHES'].replace('!count', props.count)}
        </div>
      }
      {!props.count &&
        <div className="no-results-block">
          <div className="no-results-block__inner">
            <h2 className="heading article-h2">
              { props.filters.search ? props.strings['STRING:NO_RESULTS_FOR'] + ' "' + props.filters.search + '".' : props.strings['STRING:NO_RESULTS_FOUND'] }
            </h2>
            <div className="text text-formatted">
              <ul>
                <li>{ props.strings['STRING:NO_RESULT_LIST_1'] }</li>
                <li>{ props.strings['STRING:NO_RESULT_LIST_2'] }</li>
                <li>{ props.strings['STRING:NO_RESULT_LIST_3'] }</li>
                <li>{ props.strings['STRING:NO_RESULT_LIST_4'] }</li>
              </ul>
            </div>
            <div className="no-results-block__cta">
              <div onClick={() => props.selectFilter('search', '') && props.innerResetAll() && props.updateResults(true) && props.setFilterMode(FilterModes.FILTER_MODE, false)} className="cta button">{ props.strings['STRING:SEARCH_AGAIN'] }</div>
              <a href={props.contactUsUrl} className="cta button button--ghost">{ props.strings['STRING:CONTACT_US'] }</a>
            </div>
          </div>
        </div>
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    count: state.results.count,
    render: !!(Array.isArray(state.results.result) && state.results.searchExecuted),
    filters: state.parameters.filters
  }
};

export default connect(
  mapStateToProps,
  {innerResetAll, updateResults, setFilterMode, selectFilter}
)(CountMatches)
